export const ROLES = {
  ORG_ADMIN: 'org-admin',
  PRJ_ADMIN: 'prj-admin',
  PRJ_USER: 'prj-user',
  VIEWER: 'viewer'
} as const;

export type RoleKey = (typeof ROLES)[keyof typeof ROLES];

export const ROLE_PRIORITY: RoleKey[] = [
  ROLES.ORG_ADMIN,
  ROLES.PRJ_ADMIN,
  ROLES.PRJ_USER,
  ROLES.VIEWER
];

export const ROLE_LABELS: Record<RoleKey, string> = {
  [ROLES.ORG_ADMIN]: 'Organization Admin',
  [ROLES.PRJ_ADMIN]: 'Projects Admin',
  [ROLES.PRJ_USER]: 'Project Editor',
  [ROLES.VIEWER]: 'Projects Viewer'
};
export type RoleOption = {
  key: RoleKey;
  value: RoleKey;
  label: string;
};

export const ROLE_OPTIONS: readonly RoleOption[] = [
  { key: ROLES.ORG_ADMIN, value: ROLES.ORG_ADMIN, label: 'Organisation Administrator' },
  { key: ROLES.PRJ_ADMIN, value: ROLES.PRJ_ADMIN, label: 'Project Administrator' },
  { key: ROLES.PRJ_USER, value: ROLES.PRJ_USER, label: 'Project User' },
  { key: ROLES.VIEWER, value: ROLES.VIEWER, label: 'Viewer' }
];
/*
export const ROLE_OPTIONS = [
  { key: ROLES.ORG_ADMIN, value: ROLES.ORG_ADMIN, label: 'Organisation Administrator' },
  { key: ROLES.PRJ_ADMIN, value: ROLES.PRJ_ADMIN, label: 'Project Administrator' },
  { key: ROLES.PRJ_USER, value: ROLES.PRJ_USER, label: 'Project User' },
  { key: ROLES.VIEWER, value: ROLES.VIEWER, label: 'Viewer' }
] as const;
 */

export function getHighestRole(roles: string[] = []): RoleKey | null {
  return ROLE_PRIORITY.find((role) => roles.includes(role)) ?? null;
}

export function getHighestRoleLabel(roles: string[] = []): string {
  const highestRole = getHighestRole(roles);
  return highestRole ? ROLE_LABELS[highestRole] : 'User';
}

export function hasRole(roles: string[] = [], role: RoleKey): boolean {
  return roles.includes(role);
}

export function hasAnyRole(roles: string[] = [], checkRoles: RoleKey[]): boolean {
  return checkRoles.some((role) => roles.includes(role));
}

export function getRolesLabel(rolesList: string[]) {
  return rolesList.map((role) => ROLE_OPTIONS.find((r) => r.value === role)?.label || role).join(', ');
};